import React, { useState } from 'react';
import { Button, Col, Form, Row, Select, Space, Spin, Tag, Typography } from 'antd';
import PrestationsSummaryModal from './PrestationsSummaryModal';

const { Option } = Select;
const { Text } = Typography;

const PrestationsDataBlock = ({
  t,
  form,
  reservationForm,
  index,
  totalPatients,
  patients,
  countrySettings,
  loadingServices,
  services,
  setServices,
  fetchServices,
  handleOnChangeSearch,
  repeatServicesForAllPatients,
  repeatLastPatientServices,
  updatePatientPrestations,
}) => {
  const [summaryModalVisible, setSummaryModalVisible] = useState(false);

  const getLegendClass = (type) => {
    if (!type) return 'legend-dot--protocol';
    const lowerType = String(type).toLowerCase();
    if (lowerType.includes('battery') || lowerType.includes('bateria')) return 'legend-dot--battery';
    if (lowerType.includes('exam') || lowerType.includes('examen')) return 'legend-dot--exam';
    return 'legend-dot--protocol';
  };

  const tagRender = (props) => {
    const { label } = props;
    const handleOnClose = () => {
      form.setFieldsValue({
        prestations: form.getFieldValue('prestations').filter(item => item !== props.value)
      });
      props.onClose();
    };

    return label && label.description
      ? <Tag closable onClose={(e) => { e.stopPropagation(); handleOnClose(e); }} className="select-tag">
          <Row justify='space-between' align='middle' gutter={10}>
            <Col className='flex1'>
              <Row gutter={5} align='middle'>
                <Col>
                  <div className={`legend-dot ${getLegendClass(label.type)}`} />
                </Col>
                <Col>
                  <Text className="mb-0">{label.name}</Text>
                </Col>
              </Row>
            </Col>
          </Row>
        </Tag>
      : <Tag closable onClose={(e) => { e.stopPropagation(); handleOnClose(e); }} className="select-tag select-tag--inline">
          <div className={`legend-dot ${getLegendClass(label.type)}`} />
          <Text className="mb-0">{label.name}</Text>
        </Tag>;
  };

  return (
    <>
      <h3 className='mb-10'><strong>Selección de protocolos</strong></h3>
      <Space size="middle" className="service-legend-wrapper">
        <div className="service-legend-wrapper__item"><div className="legend-dot legend-dot--battery" /> <span>Batería</span></div>
        <div className="service-legend-wrapper__item"><div className="legend-dot legend-dot--exam" /> <span>Examen individual</span></div>
        <div className="service-legend-wrapper__item"><div className="legend-dot legend-dot--protocol" /> <span>Protocolo</span></div>
      </Space>
      <Row gutter={20} className={`${((index === 0 && totalPatients > 1 && patients[index]?.prestations?.length > 0) || (patients[index - 1] && patients[index - 1]['prestations']?.length > 0 && index > 0)) ? 'mb-0' : 'mb-30'}`} align='bottom'>
        <Col lg={16} xs={24}>
          <Spin spinning={loadingServices} className='cmt-spin'>
            <Form.Item
              name="prestations"
              label="Protocolos"
              className={`patient-form exams select-wrapper ${((index === 0 && totalPatients > 1 && patients[index]?.prestations?.length > 0) || (patients[index - 1]?.prestations?.length > 0 && index > 0) || countrySettings?.generalData?.projects?.["PE"]) ? 'mb-0' : ''}`}
              rules={[{ required: true, message: 'Protocolo es requerido' }]}
            >
              <Select
                id='patientService'
                className="cmt-select w-100"
                mode="multiple"
                showArrow
                allowClear
                filterOption={false}
                placeholder="Seleccione protocolo"
                onSearch={fetchServices}
                onChange={(value, option) => handleOnChangeSearch('service', value, option)}
                onClear={() => setServices([])}
                notFoundContent={null}
                optionLabelProp="label"
                tagRender={tagRender}
              >
                {services?.map((service) => (
                  <Option
                    key={`${service.id}-${service.type}`}
                    value={`${service.id}-${service.type}`}
                    className="cmt-select-option"
                    sale_amount={service.sale_amount}
                    type={service.type}
                    name={service.name}
                    currency_code={service.currencyCode}
                    locate_code={service.locateCode}
                    country_code={service.countryCode}
                    currency_id={service.currency_id}
                    department_id={service.department_id}
                    description={service.description}
                    attached_services={service.attached_services}
                    battery_exams={service.battery_exams}
                    report_type={service.report_type}
                    medical_form_type={service.medical_form_type}
                    observations={service.observations}
                    label={{ description: service.description, name: service.name, type: service.type, sale_amount: service.sale_amount }}
                  >
                    <div className="service-select-item">
                      <div className={`legend-dot ${getLegendClass(service.type)}`} />
                      <span>{service.name}</span>
                    </div>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Spin>
        </Col>
        <Col lg={8} xs={24} className="view-summary-wrapper">
          <Button
            className="view-summary-btn"
            onClick={() => setSummaryModalVisible(true)}
          >
            Ver resumen
          </Button>
        </Col>
      </Row>
      <Row gutter={16} className={`${((index === 0 && totalPatients > 1 && patients[index]?.prestations?.length > 0) || (patients[index - 1] && patients[index - 1]['prestations']?.length > 0 && index > 0)) ? 'mb-30' : 'mb-0'}`}>
        <Col lg={16} xs={24}>
          {(index === 0 && totalPatients > 1 && patients[index].prestations.length > 0) && (
            <Button onClick={repeatServicesForAllPatients} className="cmt-button secondary non-outline p-0 left-content h-auto">
              <span className="mb-0 fs-14">{t('reservations.patientForm.repeatServicesForAll')}</span>
            </Button>
          )}
          {(patients[index - 1] && patients[index - 1]['prestations'].length > 0 && index > 0) && (
            <Button onClick={() => repeatLastPatientServices(index)} className="cmt-button secondary non-outline p-0 left-content h-auto">
              <span className="mb-0 fs-14">{t('reservations.patientForm.repeatLastServices')}</span>
            </Button>
          )}
        </Col>
      </Row>

      <PrestationsSummaryModal
        visible={summaryModalVisible}
        onClose={() => setSummaryModalVisible(false)}
        prestations={patients[index]?.prestations || []}
        evaluationType={form.getFieldValue('evaluation_type')}
        companyId={reservationForm?.getFieldValue('company_id')}
        outsourcingId={reservationForm?.getFieldValue('outsourcing_id')}
        thirdPartyId={reservationForm?.getFieldValue('third_company_id')}
        branchOfficeId={reservationForm?.getFieldValue('branch_office_id')}
        patientData={{
          ...patients[index],
          ...patients[index]?.generalData,
        }}
        onPrestationsChange={(updatedPrestations) => {
          if (updatePatientPrestations) {
            updatePatientPrestations(index, updatedPrestations);
          }
        }}
      />
    </>
  );
};

export default PrestationsDataBlock;
